var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHockey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1902 51.8383C25.0096 59.0116 30.0759 65.1274 30.0759 65.1274H40.9376L27.1902 51.8383Z",
    fill: "#592EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9131 53.9104C65.5645 53.4289 64.2502 52.9 62.9885 52.3102C62.878 52.3382 62.7635 52.3586 62.6437 52.3586L53.9164 52.359C53.1492 52.359 52.5283 51.7373 52.5283 50.97C52.5283 50.2037 53.1491 49.5824 53.9164 49.5824H58.3571C57.4678 48.9159 56.642 48.181 55.8876 47.3694H48.0256C47.2593 47.3694 46.638 46.7477 46.638 45.9813C46.638 45.215 47.2597 44.5932 48.0256 44.5932H53.8077C53.3986 43.9032 53.0312 43.1674 52.7121 42.3806H44.7947C44.0283 42.3806 43.4066 41.7589 43.4066 40.993C43.4066 40.2257 44.0283 39.6049 44.7947 39.6049H51.7288C51.4745 38.8665 51.214 38.129 50.95 37.3923H42.5288C41.7625 37.3923 41.1407 36.7706 41.1407 36.0042C41.1407 35.237 41.7624 34.6161 42.5288 34.6161H49.9355C48.7489 31.4087 47.525 28.2114 46.3788 25L40.4121 29.3755L29.6733 29.375C32.7817 34.3486 29.5725 44.668 28.023 48.9394L44.7667 65.1264H77.0055C82.3541 57.825 71.735 55.6314 66.9127 53.9106L66.9131 53.9104Z",
    fill: "#592EE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.66 67.154H30.53L28.9077 73.1593C21.6079 73.3222 21 75.9439 21 75.9439V79.1647H71.7933C82.439 77.8765 82.3378 72.9055 82.3378 72.9055L76.66 67.154ZM61.6204 75.3231H35.5057V70.9965H68.2388C68.2379 70.9965 69.2177 75.0479 61.6206 75.3231H61.6204Z",
    fill: "#592EE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHockey);
export default __webpack_public_path__ + "static/media/Hockey.7b2b4336f54af465020a82c041a44435.svg";
export { ForwardRef as ReactComponent };